import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import Button from 'components/common/Button';
import BasicModal from 'components/common/modal/BasicModal';

interface Props {
  isOpen: boolean;
  content: string | ReactNode;
  onClose: () => void;
}
const ErrorModal = ({ isOpen, content, onClose }: Props): ReactElement => {
  return (
    <BasicModal
      open={isOpen}
      onClose={onClose}
      title="Error"
      contentDividers={false}
      showCloseButton={false}
      actionButton={
        <Button variant={'text'} color={'default'} onClick={onClose}>
          Confirm
        </Button>
      }
    >
      <p>Please try again.</p>
      {content}
    </BasicModal>
  );
};

export default ErrorModal;
